import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	prioritiesLabel: {
		id: 'admin-pages-priority-schemes.priority-scheme-modal.priority-scheme-details.priorities.priorities-label',
		defaultMessage: 'Priorities',
		description: 'Label for the priorities section in the priority scheme modal',
	},
	addPrioritiesToggle: {
		id: 'admin-pages-priority-schemes.priority-scheme-modal.priority-scheme-details.priorities.add-priorities-toggle',
		defaultMessage: 'Select priorities',
		description: 'Priority picker toggle button text',
	},
});
